// AoW-front/src/utils/TokenUtils.js

export const encodePayload = (obj) => obj;
export const decodePayload = (data) => data;
export const decodeToken = (data) => data;

export const encodeToken = (data) => {
  return JSON.stringify(data);
};

export default {
  encodeToken,
  decodeToken,
  encodePayload,
  decodePayload,
};
